import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import { StoreProps } from 'src/stores'
import styled from 'styled-components'
import { media } from 'src/utils.js'

const NumberFormat = require('react-number-format')

interface Props extends StoreProps {
  productsList: any[]
  editable?: boolean
  isExternalFee?: boolean
}

interface State {
  deleteMode: boolean
  toBeDeleted: string
}

@inject('confStore')
@observer
export default class ListOfProducts extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { deleteMode: false, toBeDeleted: null }
  }

  setToBeDeleted = (uuid) => {
    this.setState({ toBeDeleted: uuid })
  }

  confirmDelete = () => {
    const { confStore } = this.props
    const { toBeDeleted } = this.state
    confStore.removeProductByUuid(toBeDeleted)
    this.setState({ toBeDeleted: null })
  }

  renderProductLine = (
    uuid,
    name,
    price,
    quantity = 1,
    canBeDeleted = false,
    isExternalFee = false
  ) => {
    const { deleteMode, toBeDeleted } = this.state
    const minus = (
      <i
        className='fas fa-minus'
        style={{ color: '#9ABBBF', marginRight: 10 }}
      />
    )
    const bin = (
      <i
        onClick={() => this.setToBeDeleted(uuid)}
        className='far fa-trash-alt'
        style={{ color: '#974353', marginRight: 10, cursor: 'pointer' }}
      />
    )
    let bullet = minus
    if (deleteMode) {
      bullet = canBeDeleted ? bin : null
    }

    // const productLabelWithQuantity = ()

    const product = (
      <Row name={name} price={price} id='product-row'>
        <Col xs={1}>
          <p
            style={{
              display: 'inline',
              margin: 0,
              float: 'left',
              color: '#4A4A4A',
              hyphens: 'auto'
            }}>
            {bullet}
          </p>
        </Col>
        <Col xs={7}>
          <p
            id='selectedProductName'
            className={`product${canBeDeleted ? 'base' : 'true'}`}
            style={{
              display: 'inline',
              margin: 0,
              float: 'left',
              color: '#4A4A4A'
            }}>
            {name}
            {quantity}
            {/* {quantity > 1 && ` (x${quantity})`} */}
          </p>
        </Col>
        <Col xs={4}>
          <div
            style={{
              display: 'inline',
              margin: 0,
              fontWeight: 'bold',
              float: 'right'
            }}>
            {price === 0
              ? ( isExternalFee? 'zu klären' : 'Inkl.')
              : (
              <NumberFormat
                value={price}
                displayType='text'
                thousandSeparator='.'
                decimalSeparator=','
                prefix='€ '
                decimalScale={2}
                fixedDecimalScale={!Number.isInteger(+price)}
              />
            )}
          </div>
        </Col>
      </Row>
    )
    const deleteQuestion = (
      <Row style={{ margin: '15px 15px 0 15px' }}>
        <Col xs={8}>Wirklich löschen?</Col>
        <Col xs={2} onClick={this.confirmDelete}>
          <p
            style={{
              textAlign: 'center',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}>
            Ja
          </p>
        </Col>
        <Col xs={2} onClick={() => this.setToBeDeleted(null)}>
          <p
            style={{
              textAlign: 'center',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}>
            Nein
          </p>
        </Col>
      </Row>
    )
    return (
      <Li key={uuid || name} style={{ paddingBottom: 10, fontSize: 15 }}>
        {toBeDeleted && uuid === toBeDeleted ? deleteQuestion : product}
      </Li>
    )
  }

  render() {
    const { confStore, productsList, editable, isExternalFee } = this.props
    const { deleteMode } = this.state
    const products = []
    const baseServices = []
    if (productsList) {
      productsList.forEach((product) => {
        const isBaseService = product.productType === 'FUNERAL'
        let locked = false;
        if(product.status === 'pending'){
          locked = true;
        }
        let name = product.name
        let price
        let quantity
        
        if(product.productType === 'CARD' || product.productType === 'OBITUARY'){
          price = product.total ? product.total.amount / 100 : confStore.calculateProductPrice(product, product.quantity)
          quantity = product.quantity > 1 && ` (x${product.quantity}) - Inkl. Versandkosten` 
        }else{
          price = product.prices ? confStore.calculateProductPrice(product, product.quantity || 1): product.price.amount / 100
          quantity = product.quantity > 1 ? ` (x${product.quantity})` : ``
        }
        let enabledItem = true;
        if(isBaseService || locked)  {
          enabledItem = false
        }

        const formatted = this.renderProductLine(
          product.uuid,
          name ,
          price,
          quantity,
          enabledItem,
          isExternalFee
        )
        if (!enabledItem) baseServices.push(formatted)
        else products.push(formatted)
      })
    }

    if( confStore.getOffer.planningReason !== 'PROVISION' && !isExternalFee){
      //adding included organization costs (only for BABB)
      const includedOrganization = this.renderProductLine(
        "ORGANIZATION_COSTS_UUID",
        "Unverbindliche Bestattungsberatung",
        0,
        null,
        false,
        false
      )
      products.push(includedOrganization)
    }

    const showEdit = editable && (products.length || deleteMode)

    return (
      <>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {baseServices}
          {products}
        </ul>
        <div
          style={{
            textAlign: 'right',
            marginBottom: 15,
            display: `${showEdit ? 'block' : 'none'}`
          }}>
          <a
            style={{
              fontSize: 16,
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
            onClick={() =>
              this.setState({ deleteMode: !deleteMode, toBeDeleted: null })
            }>
            {deleteMode ? 'Fertig' : 'Auswahl bearbeiten'}
          </a>
        </div>
      </>
    )
  }
}

const Li = styled.li`
  & p,
  span {
    ${media.tablet`
      font-size: 16px;
    `}
  }
`



// WEBPACK FOOTER //
// ./src/components/molecules/configurator/ListOfProducts.tsx